import { inject } from '@angular/core';
import { CanActivateFn, GuardResult, MaybeAsync, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';

import { hasAdminOrAbove } from '@core/models/user-role.constants';
import { selectAuthChecked, selectUser } from '@core/store/auth/auth.selectors';

export const adminGuard: CanActivateFn = (): MaybeAsync<GuardResult> => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectAuthChecked).pipe(
    filter((checked) => checked),
    take(1),
    map(() => {
      const user = store.selectSignal(selectUser);
      const currentUser = user();
      if (hasAdminOrAbove(currentUser?.role)) {
        return true;
      }
      return router.createUrlTree(['/']);
    })
  );
};
